// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2kWTH","footer":"ModalError_footer__3y8fm"};